<template>
  <div class="warehousing">
    <div v-if="haveRight">
      <header class="warehousing-header">
        <h1 class="warehousing-username">
          <span>{{userInfo.worksite.shortName}} - {{userInfo.worksite.schoolCampus}}</span>
          <span class="worksite-info">
            <p class="school-name">（{{userInfo.nameZH}}）</p>
          </span>
        </h1>
      </header>
      <div class="weui-cells">
        <a class="weui-cell weui-cell_access" href="javascript:;" @click="chooseExpress">
          <div class="weui-cell__bd">
            <p>快递公司</p>
          </div>
          <div class="weui-cell__ft">{{currExpressCompany.name?currExpressCompany.name:'请选择'}}</div>
        </a>
        <a class="weui-cell weui-cell_access" href="javascript:;" @click="scanStorageNo">
          <div class="weui-cell__bd">
            <p>货架编号</p>
          </div>
          <div class="weui-cell__ft">{{storageNo?storageNo:'扫描货架编号'}}</div>
        </a>
        <a class="weui-cell weui-cell_access" href="javascript:;" @click="scanExpressNo">
          <div class="weui-cell__bd">
            <p>快递单号</p>
          </div>
          <div class="weui-cell__ft">{{expressNo?expressNo:'扫描快递单号'}}</div>
        </a>
        <div class="weui-cell weui-cell_vcode">
          <div class="weui-cell__hd">
            <label class="weui-label">收件电话</label>
          </div>
          <div class="weui-cell__bd weui-cell__bd_span">
            {{isLast4NumberInput?receiver.receiverShortPhone:receiver.receiverPhone}}
          </div>
          <div class="weui-cell__ft" @click="changeInputType">
            <button class="weui-vcode-btn">{{isLast4NumberInput?"后四位":"全号码"}}
              <i class="iconfont icon-qiehuan" aria-hidden="true"></i>
            </button>
          </div>
        </div>
        <div class="weui-cell weui-cell_select weui-cell_select-after">
          <div class="weui-cell__hd">
            <label for="" class="weui-label">大概重量</label>
          </div>
          <div class="weui-cell__bd">
            <select class="weui-select" name="select2" v-model="currWeightFeeId">
              <option :value="item._id" v-for="item in weightFees" :key="item._id">{{item.name}}</option>
            </select>
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__bd">
            <p>上个编码</p>
          </div>
          <div class="weui-cell__ft">{{storageNo&&autoStorageNo?storageNo+' [ '+autoStorageNo+' ]':"暂无"}}</div>
        </div>
      </div>
      <div class="weui-grids keyboard">
        <a href="javascript:;" class="weui-grid" @click="numberClick(1)">
          <p class="weui-grid__label number">1</p>
        </a>
        <a href="javascript:;" class="weui-grid" @click="numberClick(2)">
          <p class="weui-grid__label number">2</p>
        </a>
        <a href="javascript:;" class="weui-grid" @click="numberClick(3)">
          <p class="weui-grid__label number">3</p>
        </a>
        <a href="javascript:;" class="weui-grid" @click="numberClick(4)">
          <p class="weui-grid__label number">4</p>
        </a>
        <a href="javascript:;" class="weui-grid" @click="numberClick(5)">
          <p class="weui-grid__label number">5</p>
        </a>
        <a href="javascript:;" class="weui-grid" @click="numberClick(6)">
          <p class="weui-grid__label number">6</p>
        </a>
        <a href="javascript:;" class="weui-grid" @click="numberClick(7)">
          <p class="weui-grid__label number">7</p>
        </a>
        <a href="javascript:;" class="weui-grid" @click="numberClick(8)">
          <p class="weui-grid__label number">8</p>
        </a>
        <a href="javascript:;" class="weui-grid" @click="numberClick(9)">
          <p class="weui-grid__label number">9</p>
        </a>
        <a href="javascript:;" class="weui-grid" @click="clear">
          <p class="weui-grid__label wenzi">清空</p>
        </a>
        <a href="javascript:;" class="weui-grid" @click="numberClick(0)">
          <p class="weui-grid__label number">0</p>
        </a>
        <a href="javascript:;" class="weui-grid" @click="deleteLastNumber">
          <p class="weui-grid__label wenzi">退格</p>
        </a>
      </div>

      <div class="footer-item" @click="warehousing">
        <a href="javascript:;">确认入库</a>
      </div>

      <div id="toast" v-show="isShowingAutoStorageNumber">
        <div class="weui-mask_transparent"></div>
        <div class="weui-toast">
          <p class="storageno">{{autoStorageNo}}</p>
          <p class="weui-toast__content">已完成</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import weui from "weui.js";
import axios from "axios";
const wx = require("weixin-js-sdk");

export default {
  data() {
    return {
      encodeToken: "",
      token: "",
      userInfo: {
        worksite: {}
      },
      haveRight: false,
      expressNo: '',
      storageNo: "",
      autoStorageNo: "",
      isShowingAutoStorageNumber: false,
      currExpressCompany: {
        _id: "",
        name: ""
      },
      expressCompanies: [],
      ecPicker: [
        {
          label: "请选择",
          value: ""
        }
      ],
      weightFees: [],
      initWeightFee: "",
      currWeightFeeId: "",
      isLast4NumberInput: true,
      receiver: {
        receiverShortPhone: "",
        receiverPhone: ""
      }
    };
  },
  created() {
    let that = this;
    this.encodeToken = this.$route.params.token;
    this.token = decodeURIComponent(this.encodeToken);
    axios.defaults.headers["Authorization"] = "Bearer " + this.token;

    let url = window.location.href;
    let params = {
      url: url
    };
    let jsConfig = {};
    axios
      .get("/api/wx/jsconfig", { params })
      .then(res => {
        jsConfig = res.data.data;
        jsConfig.jsApiList = ["scanQRCode"];
        wx.config(jsConfig);
      })
      .catch(err => {
        console.log(err);
      });

    // 根据token查找微信用户信息
    axios
      .get("/api/user/wxuserInfo")
      .then(response => {
        if (response.data.success) {
          let openid = response.data.data.openid;
          // 根据openid 获取用户信息
          axios
            .get("/auth/employee/getByOpen/" + openid)
            .then(res => {
              if (res.data.success) {
                this.haveRight = true;
                that.userInfo = res.data.user;

                let expressCompanyIds = this.userInfo.worksite.expressCompanies;
                params = {
                  _id: {
                    $in: expressCompanyIds
                  }
                };

                axios
                  .get("api/expressCompany/list", { params })
                  .then(response => {
                    this.expressCompanies = response.data.data;
                    for (let i = 0; i < this.expressCompanies.length; i++) {
                      let item = {
                        label: this.expressCompanies[i].name,
                        value: this.expressCompanies[i]._id
                      };
                      this.ecPicker.push(item);
                    }
                  })
                  .catch(error => {
                    weui.topTips("获取快递公司列表失败", 2000);
                  });

                // 获取重量费用类型
                axios
                  .get("/api/dict/detail/weightFeeType")
                  .then(response => {
                    this.weightFees = response.data.data.values;
                    if (this.weightFees.length > 0) {
                      this.initWeightFee = this.weightFees[0]._id;
                      this.currWeightFeeId = this.weightFees[0]._id;
                    }
                  })
                  .catch(error => {
                    weui.topTips("获取重量费用类型列表失败", 2000);
                  });
              } else {
                weui.alert("请先绑定后台操作用户", function() {
                  that.$router.push("/bind/warehousing/" + that.encodeToken);
                });
              }
            })
            .catch(err => {
              weui.alert("获取用户信息失败");
            });
        }else {
          weui.alert("获取用户信息失败");
        }
      })
      .catch(error => {
        weui.alert("获取用户信息失败");
      });
  },
  methods: {
    logout() {
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("userInfo");
      this.$router.push("/login");
    },
    chooseExpress() {
      let that = this;
      weui.picker(this.ecPicker, {
        className: "custom-classname",
        container: "body",
        defaultValue: [""],
        onChange: function(result) {},
        onConfirm: function(result) {
          that.currExpressCompany = {
            _id: result[0].value,
            name: result[0].label
          };
        },
        id: "expressCompanyPicker"
      });
    },
    scanStorageNo() {
      let that = this;
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: function(res) {
          let scanResult = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
          if (scanResult.indexOf(",") >= 0) {
            // 扫描一维码的时候会返回一维码的编码规则
            that.storageNo = scanResult.substring(scanResult.indexOf(",") + 1);
          } else {
            that.storageNo = scanResult;
          }
        }
      });
    },
    scanExpressNo() {
      let that = this;
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: function(res) {
          let scanResult = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
          if (scanResult.indexOf(",") >= 0) {
            // 扫描一维码的时候会返回一维码的编码规则
            that.expressNo = scanResult.substring(scanResult.indexOf(",") + 1);
          } else {
            that.expressNo = scanResult;
          }
        }
      });
    },
    numberClick(value) {
      let that = this;
      if (this.isLast4NumberInput) {
        if (this.receiver.receiverShortPhone.length == 4) {
          this.receiver.receiverShortPhone = String(value);
        } else {
          this.receiver.receiverShortPhone += value;
          if (this.receiver.receiverShortPhone.length == 4) {
            // 已经输完后四位， 查询数据库比对电话号码
            axios
              .get(
                "api/user/list/" +
                  this.userInfo.worksite._id +
                  "/" +
                  this.receiver.receiverShortPhone
              )
              .then(response => {
                let users = response.data.data;
                let menus = [];
                if (users.length > 0) {
                  for (let i = 0; i < users.length; i++) {
                    let user = users[i];
                    let phoneMain = user.phoneMain;
                    let phoneVice = user.phoneVice;

                    let reg = new RegExp(
                      that.receiver.receiverShortPhone + "$"
                    );

                    let receiver = user.realname
                      ? user.realname
                      : user.nickname.substr(0, 4);
                    if (reg.test(phoneMain)) {
                      let menu = {
                        label: phoneMain + " - " + receiver,
                        onClick: function() {
                          that.receiver.receiverId = user._id;
                          that.receiver.subscribe = user.subscribe;
                          that.receiver.receiverOpenid = user.openid;
                          that.receiver.receiver = receiver;
                          that.receiver.receiverPhone = phoneMain;
                          that.isLast4NumberInput = !that.isLast4NumberInput;
                        }
                      };
                      menus.push(menu);
                    }
                    if (reg.test(phoneVice)) {
                      let menu = {
                        label: phoneVice + " - " + receiver,
                        onClick: function() {
                          that.receiver.receiverId = user._id;
                          that.receiver.subscribe = user.subscribe;
                          that.receiver.receiverOpenid = user.openid;
                          that.receiver.receiver = receiver;
                          that.receiver.receiverPhone = phoneVice;
                          that.isLast4NumberInput = !that.isLast4NumberInput;
                        }
                      };
                      menus.push(menu);
                    }
                  }

                  weui.actionSheet(
                    menus,
                    [
                      {
                        label: "取消",
                        onClick: function() {
                          that.receiver = {
                            receiverPhone: "",
                            receiverShortPhone: ""
                          };
                        }
                      }
                    ],
                    {
                      className: "custom-classname",
                      onClose: function() {}
                    }
                  );
                } else {
                  that.receiver = {
                    receiverPhone: "",
                    receiverShortPhone: ""
                  };
                  weui.alert(
                    "暂无匹配的用户，请手动输入收件人电话或按照规定操作。"
                  );
                }
              })
              .catch(error => {
                weui.topTips(error, 1000);
              });
          }
        }
      } else {
        if (this.receiver.receiverPhone.length < 11) {
          this.receiver.receiverPhone += value;
        }
      }
    },
    deleteLastNumber() {
      if (
        this.isLast4NumberInput &&
        this.receiver.receiverShortPhone.length > 0
      ) {
        this.receiver.receiverShortPhone = this.receiver.receiverShortPhone.substr(
          0,
          this.receiver.receiverShortPhone.length - 1
        );
      } else {
        this.receiver.receiverPhone = this.receiver.receiverPhone.substr(
          0,
          this.receiver.receiverPhone.length - 1
        );
      }
    },
    clear() {
      this.receiver.receiverShortPhone = "";
      this.receiver.receiverPhone = "";
    },
    changeInputType() {
      this.receiver.receiverShortPhone = "";
      this.receiver.receiverPhone = "";
      this.isLast4NumberInput = !this.isLast4NumberInput;
    },
    gotoTakepart() {
      this.$router.push("/takepart");
    },
    warehousing() {
      let that = this;
      if (!this.currExpressCompany._id) {
        weui.alert("请选择快递公司");
        return;
      } else if (!this.storageNo) {
        weui.alert("请扫描货架编号");
        return;
      } else if (!this.expressNo) {
        weui.alert("请扫描快递单号");
        return;
      } else if (!this.currWeightFeeId) {
        weui.alert("请选择大概重量");
        return;
      } else {
        if (!this.receiver.receiverPhone) {
          weui.alert("收件电话为空");
          return;
        } else if (this.receiver.receiverPhone.length != 11) {
          weui.alert("请检查收件电话是否正确");
          return;
        }
      }

      let params = {
        worksite: this.userInfo.worksite._id,
        worksiteCode: this.userInfo.worksite.siteCode,
        worksiteSmsAble: this.userInfo.worksite.smsAble ? true : false,
        serviceTimeStr: this.userInfo.worksite.serviceBegin + ' - ' + this.userInfo.worksite.serviceEnd,
        servicePhone: this.userInfo.servicePhone,
        expressCompany: this.currExpressCompany._id,
        expressName: this.currExpressCompany.name,
        expressNo: this.expressNo,
        storageNo: this.storageNo,
        tag: this.autoStorageNo,
        weight: this.currWeightFeeId,
        receiver: this.receiver.receiver,
        receiverId: this.receiver.receiverId,
        receiverOpenid: this.receiver.receiverOpenid,
        receiverPhone: this.receiver.receiverPhone,
        subscribe: this.receiver.subscribe
      };

      axios
        .post("/api/expressTosend", params)
        .then(response => {
          if (response.data.success) {
            this.autoStorageNo = response.data.data;
            this.isShowingAutoStorageNumber = true;
            setTimeout(function() {
              that.isShowingAutoStorageNumber = false;
              this.autoStorageNo = "";
            }, 2000);
            this.receiver = {
              receiverShortPhone: "",
              receiverPhone: ""
            };
            this.isLast4NumberInput = true;
            this.currWeightFeeId = this.initWeightFee;
            this.expressNo = "";
          } else {
            weui.alert(response.data.message);
          }
        })
        .catch(error => {
          weui.alert("入库失败");
        });
    }
  }
};
</script>
<style scoped>
.size-20 {
  font-size: 20px;
}
.size-25 {
  font-size: 25px;
}
.weui-grid {
  padding: 10px;
}
.weui-cells {
  margin-top: 0px;
}
.weui-cell__bd_span {
  text-align: right;
}
.keyboard {
  background-color: #eee;
}
.warehousing {
  margin: 0 auto;
  position: relative;
  font-size: 16px;
}
.warehousing-username {
  height: 50px;
  line-height: 50px;
  background-color: #1aad19;
  color: white;
  position: relative;
  font-size: 25px;
}
.warehousing-local {
  margin-top: 10px;
  margin-bottom: 10px;
  color: coral;
}
.warehousing-out-icon {
  position: absolute;
  right: 10px;
  top: 1px;
}
.warehousing-header {
  text-align: center;
}
.warehousing-header-nav {
  margin-top: 20px;
  height: 33px;
  position: relative;
}
.warehousing-header-nav:before {
  content: "";
  position: absolute;
  left: 0px;
  bottom: 0px;
  width: 100%;
  height: 2px;
  border-bottom: 1px solid #ccc;
}
.courier-company {
  position: absolute;
  left: 0px;
  height: 100%;
}
.courier-company-taget {
  position: absolute;
  right: 0px;
  height: 100%;
}
.addboxshadow {
  box-shadow: inset 0px 0px 10px #1aad19;
}
.weui-grid.select {
  color: #1aad19;
  box-shadow: inset 0px 0px 10px #1aad19;
}
.weui-grid .weui-grid__label.number {
  font-size: 24px;
}
.weui-grid .weui-grid__label.wenzi {
  font-size: 18px;
  padding-top: 5px;
  padding-bottom: 5px;
}
.weui-grid.select .weui-grid__label {
  color: #1aad19;
  font-weight: bold;
}
.form-item-label {
  width: 80px;
}
.form-item-input {
  flex: 1;
}
.form-item-input input {
  display: block;
  border: 0px;
  width: 100%;
  height: 100%;
  line-height: 34px;
  padding-left: 5px;
  border: 1px solid #eee;
}
.warehousing-input-num {
  display: flex;
  justify-content: space-around;
  margin-top: 10px;
}
.warehousing-input-num div {
  width: 20%;
  font-size: 40px;
  text-align: center;
  color: #1aad19;
}
.warehousing-server {
  width: 90%;
  margin: 0 auto;
  margin-top: 15px;
  padding-bottom: 60px;
}
.warehousing-server-item {
  font-size: 20px;
  text-align: left;
  border: 1px solid #ddd;
  padding: 5px;
  position: relative;
  overflow: hidden;
  padding-left: 20px;
}
.warehousing-server-item + .warehousing-server-item {
  margin-top: 10px;
}
.warehousing-server-item .item-icon {
  width: 30px;
  text-align: center;
  vertical-align: middle;
  font-size: 22px;
  display: inline-block;
}
.warehousing-server-item .item-server {
  text-align: left;
  display: inline-block;
  vertical-align: middle;
  font-size: 20px;
  position: relative;
}
.item-server + .item-server {
  margin-left: 20px;
}
.warehousing-server-item.select {
  border: 1px solid #1aad19;
}
.warehousing-server-item.select:before {
  content: "";
  position: absolute;
  right: -15px;
  top: -15px;
  width: 30px;
  height: 30px;
  background-color: #1aad19;
  transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  -moz-transform: rotate(-45deg);
}
.warehousing-server-item.select:after {
  content: "\f00c";
  position: absolute;
  right: 0px;
  top: 0px;
  font: normal normal normal 14px/1 FontAwesome;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  color: white;
  font-size: 12px;
}

.warehousing footer {
  position: fixed;
  bottom: 0px;
  left: 0px;
  width: 100%;
  height: 60px;
}
.warehousing-footer {
  display: flex;
  border-top: 1px solid #eee;
  background-color: #fff;
  position: relative;
}
.warehousing-footer-item {
  flex: 1;
  font-size: 18px;
  text-align: center;
  font-weight: bold;
}
.warehousing-footer-item.select {
  color: orange;
}
.warehousing-footer-item_text {
  font-size: 16px;
  margin-top: -10px;
}
.sureinwarehousing {
  line-height: 60px;
  background-color: #1aad19;
  color: white;
  margin-top: 0px;
  box-shadow: 0px 0px 5px #1aad19;
}
.sureinwarehousing a {
  color: white;
  font-size: 20px;
  font-weight: bold;
}
.weui-toast .storageno {
  margin-top: 10px;
  font-size: 80px;
  line-height: 80px;
}
.weui-toast__content {
  margin: 0px;
}
.worksite-info {
  font-size: 14px;
  font-weight: normal;
  position: absolute;
  right: 0;
}
.school-name {
  line-height: 50px;
  margin-right: 10px;
  padding-top: 6px;
}
.footer-item {
  flex: 1;
  font-size: 18px;
  text-align: center;
  line-height: 50px;
  background-color: #1aad19;
}
.footer-item a {
  color: #ffffff;
}
</style>
<style>
.weui-picker__item {
  font-size: 18px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Warehousing.vue